import { t } from "i18next";
import { useState } from "react";
import { Ban, ListChecks } from "lucide-react";

import { RowActionsMenu } from "@/core/components/shared/data-table";
import type { ApiClientDto } from "@/features/admin/api/dto";
import { ApiClientRevokeDialog } from "@/features/admin/components/api-clients/api-client-revoke-dialog";
import { ApiClientScopesDialog } from "@/features/admin/components/api-clients/api-client-scopes-dialog";

/**
 * Menu d'actions de ligne d'un client API : modification des scopes et
 * révocation (confirmations dédiées). Révocation masquée si déjà REVOKED.
 */
export function ApiClientRowActions({
  apiClient,
}: {
  apiClient: ApiClientDto;
}) {
  const [scopesOpen, setScopesOpen] = useState(false);
  const [revokeOpen, setRevokeOpen] = useState(false);

  return (
    <>
      <RowActionsMenu
        actions={[
          {
            id: "edit-scopes",
            label: t("admin.apiClients.actions.editScopes"),
            icon: ListChecks,
            onClick: () => setScopesOpen(true),
          },
          ...(apiClient.status !== "REVOKED"
            ? [
                {
                  id: "revoke",
                  label: t("admin.apiClients.actions.revoke"),
                  icon: Ban,
                  variant: "destructive" as const,
                  onClick: () => setRevokeOpen(true),
                },
              ]
            : []),
        ]}
      />

      <ApiClientScopesDialog
        apiClient={apiClient}
        open={scopesOpen}
        onOpenChange={setScopesOpen}
      />
      <ApiClientRevokeDialog
        apiClient={apiClient}
        open={revokeOpen}
        onOpenChange={setRevokeOpen}
      />
    </>
  );
}
